import {AccountManagementServicesInstantiatorService} from '@modules/account-management';
import {ActivitiesServicesInstantiatorService} from '@modules/activities';
import {AuthenticationServicesInstantiatorService} from '@modules/authentication';
import {BasicPageService} from 'fuse-core/components/basic-page/basic-page.service';
import {ConfigurationService} from '@modules/configuration';
import {FormDialogService} from 'fuse-core/components/form-dialog/form-dialog.service';
import {GlobalAuthorizationService} from '../../../../src/app/global-authorization.service';
import {Injectable} from '@angular/core';
import {LrsService} from '@modules/lrs';
import {MindmapServicesInstantiatorService} from '@modules/mindmap';
import {NewsService} from 'fuse-core/news/news.service';
import {NotepadServicesInstantiatorService} from '@modules/notepad';
import {SnackbarNewsService} from 'fuse-core/news/snackbar/snackbar-news.service';
import {SvgIconList} from '../../../../src/app/themes/isc_college/svgIconList';
import {TimelineService} from '@modules/timeline';

@Injectable()
export class ServiceInstantiator {

    constructor(
        private _accountManagementServices: AccountManagementServicesInstantiatorService,
        private _activitiesServices: ActivitiesServicesInstantiatorService,
        private _authenticationServices: AuthenticationServicesInstantiatorService,
        private _basicPageService: BasicPageService,
        private _configurationService: ConfigurationService,
        private _formDialogService: FormDialogService,
        private _globalAuthorizationService: GlobalAuthorizationService,
        private _lrsService: LrsService,
        private _mindmapServices: MindmapServicesInstantiatorService,
        private _newsService: NewsService,
        private _notepadServices: NotepadServicesInstantiatorService,
        private _snackbarNewsService: SnackbarNewsService,
        private _svgIconList: SvgIconList,
        private _timelineService: TimelineService,
    ) {
    }

}
